<template>
  <div v-if="$store.state.manager.role !== 'Administrator'">
    <p>You don't have permission to access this page</p>
  </div>
  <div v-else>
    <v-tabs v-model="tab">
      <v-tab>
        Managers
      </v-tab>
      <v-tab>
        Archived Events
      </v-tab>
      <v-tab>
        Allowed Domains
      </v-tab>
    </v-tabs>
    <v-tabs-items v-model="tab">
      <v-tab-item>
        <v-dialog v-model="dialog" max-width="600">
          <v-card>
            <v-card-title>Add New Manager</v-card-title>
            <v-card-text>
              <p style="color:red;" v-if="formErrors">{{ formErrors }}</p>
              <v-form v-model="isFormValid">
                <v-text-field
                  v-model="manager.firstName"
                  label="First Name"
                  :rules="[rules.required]"
                ></v-text-field>
                <v-text-field
                  v-model="manager.lastName"
                  label="Last Name"
                  :rules="[rules.required]"
                ></v-text-field>
                <v-text-field
                  :rules="[rules.password]"
                  v-model="manager.password"
                  label="Password"
                ></v-text-field>
                <v-text-field
                  type="email"
                  v-model="manager.email"
                  label="Email"
                  :rules="[rules.requiredSelect]"
                ></v-text-field>
                <v-select
                  v-model="manager.role"
                  :items="['Administrator', 'Analyst']"
                  label="Role"
                  :rules="[rules.required]"
                >
                </v-select>
              </v-form>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn @click="saveManager" color="primary">Save</v-btn>
              <v-btn @click="dialog = false" color="primary">Cancel</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
        <v-row>
          <v-col>
            <v-card>
              <v-card-text>
                <v-simple-table dense>
                  <template v-slot:top>
                    <v-toolbar flat>
                      <v-toolbar-title>Managers</v-toolbar-title>
                      <v-divider class="mx-4" inset vertical></v-divider>
                      <v-spacer></v-spacer>
                      <v-btn @click="dialog = true" small color="primary"
                        >Add New Manager</v-btn
                      >
                    </v-toolbar>
                  </template>
                  <template v-slot:default>
                    <thead>
                      <tr>
                        <th class="text-left">
                          Name
                        </th>
                        <th class="text-left">
                          email/username
                        </th>
                        <th class="text-left">
                          Last sign-in
                        </th>
                        <th class="text-left">
                          Role
                        </th>
                        <th class="text-left">Remove</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="item in managers" :key="item._id">
                        <td>{{ item.firstName }} {{ item.lastName }}</td>
                        <td>{{ item.email }}</td>
                        <td>
                          <span v-if="item.lastAccess">{{
                            item.lastAccess | getTimeAgo
                          }}</span>
                          <span v-else>Never</span>
                        </td>
                        <td>{{ item.role }}</td>
                        <td>
                          <v-icon
                            @click="deleteManager(item._id)"
                            small
                            class="mr-2"
                            >mdi-delete</v-icon
                          >
                        </td>
                      </tr>
                    </tbody>
                  </template>
                </v-simple-table>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
      </v-tab-item>
      <v-tab-item>
        <v-row>
          <v-col>
            <v-card>
              <v-card-title>Archived Events</v-card-title>
              <v-divider></v-divider>
              <v-card-text>
                <v-simple-table dense>
                  <template v-slot:default>
                    <thead>
                      <tr>
                        <th class="text-left">
                          Event
                        </th>
                        <th class="text-left">
                          Start Date
                        </th>
                        <th class="text-left">Action</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="item in events" :key="item._id">
                        <td>{{ item.name }}</td>
                        <td>{{ item.startDate | getDateWithTz }}</td>
                        <td>
                          <v-btn
                            text
                            small
                            color="primary"
                            @click="restoreEvent(item._id)"
                            >restore</v-btn
                          >
                          <v-btn
                            text
                            small
                            color="red"
                            @click="deleteEvent(item._id)"
                            dark
                            >delete permanently</v-btn
                          >
                        </td>
                      </tr>
                    </tbody>
                  </template>
                </v-simple-table>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
      </v-tab-item>
      <v-tab-item>
        <v-card>
          <v-card-title>Allowed Domains</v-card-title>
          <v-divider></v-divider>
          <v-card-text>
            <p>
              If you embed the AGMify client on external hosts, enter their
              domain names in the box below. Each domain must be on a separate
              line. You must include the prefix http or https.
            </p>
            <v-textarea
              @change="domainSaveFlag = false"
              outlined
              label="Allowed domains"
              v-model="domains"
            ></v-textarea>
          </v-card-text>
          <v-card-actions class="justify-center">
            <v-btn
              color="primary"
              :disabled="domainSaveFlag"
              @click="saveDomains"
              >Save</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-tab-item>
    </v-tabs-items>
  </div>
</template>
<script>
import api from "@/services/api";
import moment from "moment-timezone";
export default {
  data: () => {
    return {
      domains: "",
      domainSaveFlag: true,
      tab: null,
      dialog: false,
      loading: false,
      managers: null,
      manager: {},
      events: null,
      formErrors: "",
      isFormValid: false,
      rules: {
        required: (value) => !!value || "Required.",
        requiredSelect: (value) => (value && value.length > 0) || "Required.",
        password: (value) => {
          const pattern = /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$%^&*])(?=.{8,})/;
          return (
            pattern.test(value) ||
            "Min. 8 characters with at least one capital letter, a number and a special character."
          );
        }
      }
    };
  },
  async created() {
    await this.updateTable();

    const domainsJson = await api.getDomains();
    if (domainsJson.domains.length)
      this.domains = domainsJson.domains.join("\r");
  },
  methods: {
    async updateTable() {
      this.managers = await api.getManagers();
      this.events = await api.getArchivedEvents();
    },
    async restoreEvent(id) {
      if (confirm("Are you sure you want to restore this event?")) {
        await this.$store.dispatch("restoreEvent", id);
        await this.updateTable();
      }
    },
    async deleteEvent(id) {
      if (confirm("Are you sure you want to permanently delete this event?")) {
        await this.$store.dispatch("deleteEvent", id);
        await this.updateTable();
      }
    },
    async saveManager() {
      try {
        if (this.isFormValid) {
          await api.saveManager(this.manager);
          await this.updateTable();
          this.dialog = false;
        }
      } catch (error) {
        this.formErrors = error.error;
      }
    },
    async deleteManager(id) {
      if (confirm("Are you sure want to delete this manager?")) {
        await api.deleteManager(id);
        await this.updateTable();
      }
    },
    async saveDomains() {
      console.log(this.domains);
      //console.log({ domains: this.domains.split("\r") });
      await api.saveDomains({ domains: this.domains.split("\n") });
      this.domainSaveFlag = true;
    }
  },
  filters: {
    getDateWithTz(startDate) {
      let dateFormat = "LLLL z";
      return moment(startDate).format(dateFormat);
    },
    getTimeAgo(fromDate) {
      return moment(fromDate).fromNow();
    }
  }
};
</script>
